// extracted by mini-css-extract-plugin
export var actions = "_v5-4";
export var item = "_v5-1";
export var price = "_v5-3";
export var quantity = "_v5-2";
export var table = "_v5-0";